export default "__VITE_ASSET__D962siUN__"